import type { KataDefinition, Technique } from './types'

function openingBow(kataId: string): Technique {
  return {
    id: `${kataId}-kaishi-rei`,
    name: 'Opening bow',
    nameJa: '開始礼',
    nameZh: '開始禮',
    searchAliases: ['Kaishi-rei', 'Kaishi rei', '開始禮', '開始礼'],
  }
}

function closingBow(kataId: string): Technique {
  return {
    id: `${kataId}-shuryo-rei`,
    name: 'Closing bow',
    nameJa: '終了礼',
    nameZh: '結束禮',
    searchAliases: ['Shuryo-rei', 'Shuryo rei', '結束禮', '終了礼'],
  }
}

/**
 * Prepends 開始礼 / Opening bow and appends 終了礼 / Closing bow
 * in catalog performance order without changing group structure.
 */
export function withOpeningAndClosingBows(kata: KataDefinition): KataDefinition {
  const { groups } = kata
  if (groups.length === 0) return kata

  const opening = openingBow(kata.id)
  const closing = closingBow(kata.id)

  if (groups.length === 1) {
    const only = groups[0]
    return {
      ...kata,
      groups: [
        {
          ...only,
          techniques: [opening, ...only.techniques, closing],
        },
      ],
    }
  }

  const lastIndex = groups.length - 1
  return {
    ...kata,
    groups: groups.map((group, index) => {
      if (index === 0) {
        return { ...group, techniques: [opening, ...group.techniques] }
      }
      if (index === lastIndex) {
        return { ...group, techniques: [...group.techniques, closing] }
      }
      return group
    }),
  }
}
